<template>
  <el-dialog
    title="转交线索"
    :visible.sync="dialogVisible"
    width="480px"
    custom-class="MyDialog"
    @close="closeDialog"
    append-to-body
  >
    <el-form class="handover-clue" ref="handoverForm" label-width="70px">
      <div class="handover-tip">转交后，线索跟进人将更新为您指定的同事，请选择您要转交的员工账号</div>
      <el-form-item class="form-item-staff" label="选择员工">
        <el-select v-model="handoverStaff" filterable placeholder="请选择员工">
          <el-option
            v-for="item in staffList"
            :key="item.userId"
            :label="item.userName"
            :value="item.userId"
          >
          </el-option>
        </el-select>
        <div class="help-text">仅账号状态为“正常”的员工可进行转交</div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button @click="transferCustom" type="primary">确认</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getCampusNormalUsers } from "@/api/CallCenter";
import { changeCustomCrOwner,changeCustomOwner } from "@/api/studentDetails";
import LoginUserHelper from "@/util/LoginUserHelper";

export default {
  props: {
    showTransferClueDialog: {
      type: Boolean,
      default: false
    },
    currentCustomId: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      // 转交线索
      dialogVisible: false,
      staffList: [], // 员工列表
      handoverStaff: '',
    };
  },
  watch: {
    showTransferClueDialog(val) {
      this.dialogVisible = val;
      if (val) {
        this.fetchStaffList();
      } else {
        this.resetForm();
      }
    },
  },
  mounted() {
    this.dialogVisible = this.showTransferClueDialog;
  },
  methods: {
    // 转交线索按钮点击
    fetchStaffList () {
      this.resetForm();
      getCampusNormalUsers({}).then(ret => {
        if (ret.code === 0) {
          this.staffList = ret.data || [];
        }
      });
    },
    // 转交线索
    transferCustom() {
      const params = {
        customIds: this.currentCustomId,
        newOwner: this.handoverStaff,
        agentUserId: LoginUserHelper.getUserInfo().id,
        pointType: 8900902,
      };
      changeCustomOwner(params).then(ret => {
        if (ret.code === 0) {
          this.$message({ message: '转交成功', type: "success" });
          this.closeDialog();
          this.$emit('update:clueList');
        } else {
          this.$message({ message: ret.message || '转交失败', type: "warning" });
        }
      }).catch(error => {
        this.$message({ message: '转交失败', type: "error" });
      });
    },
    closeDialog() {
      this.dialogVisible = false;
      this.resetForm();
      this.$emit('update:closeTransferClueDialog');
    },
    resetForm() {
      this.handoverStaff = '';
    },
  }
};
</script>

<style lang="scss" scoped>
// 线索转交
.handover-clue {
	padding: 0 20px;
	.handover-tip {
		line-height: 24px;
		margin-bottom: 12px;
		color: #333;
		font-size: 14px;
	}
	.help-text {
		color: #EE4B4E;
		font-size: 12px;
		line-height: 18px;
		margin-top: 2px;
	}
	.form-item-staff {
		margin-bottom: 0;
	}
}
</style>
